export default "__VITE_ASSET__BFDs338S__"